import { IGroupSpaceResource } from "../../group-spaces";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IPaginateable,
    mapPagination,
    mapRelationalFilter,
    RelationalFilter,
    serialize,
} from "../../utils";
import { IGroupWorkList } from "../types";

export interface IGroupWorkListQueryParameters extends IPaginateable {
    filters: {
        groupSpace: RelationalFilter<IGroupSpaceResource>;
    };
}

export type IGroupWorkListQueryResult = IGroupWorkList;

const mapFilters = (filters: IGroupWorkListQueryParameters["filters"]) => {
    const { groupSpace } = filters;
    return {
        "groupSpace.uuid": mapRelationalFilter(groupSpace),
    };
};

export const groupWorkListQuery: IApiQueryFunction<IGroupWorkListQueryParameters> = ({ filters, pagination }) => {
    return {
        method: "GET",
        url: `/group_works${serialize(
            {
                ...mapPagination(pagination),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useGroupWorkListQuery = createApiQueryHook<IGroupWorkListQueryParameters, IGroupWorkListQueryResult>(
    groupWorkListQuery,
);
